export default __webpack_public_path__ + "static/media/blazepay_block_logo.4e492e44.svg";